module.exports = __webpack_public_path__ + "static/media/picture-outlined-blue.8787724f.svg";